import app from 'firebase/app'
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

/* Values in process.env come from SPA/.env* files, which are gitignored */
const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
}
const actionCodeSettings = {
  url: process.env.REACT_APP_URL + "/sign-in", // Redirect page
}
class Firebase {
  constructor() {
    !app.apps.length && app.initializeApp(config)
    this.providerGoogle = new app.auth.GoogleAuthProvider()
    /* SOMEDAY, add scopes like
    this.providerGoogle.addScope('https://www.googleapis.com/auth/contacts.readonly') */
    this.auth = app.auth()
    this.auth.useDeviceLanguage()
    this.database = app.database()
    
    // Introducing Firestore, in parallel with Firebase Realtime Database 
    this.firestore = app.firestore()
    // const firestoreSettings = {timestampsInSnapshots: true};
    // this.firestore.settings(firestoreSettings);
  }
  
  // *** Auth API ***
  doCreateUserWithEmailAndPassword = (email, password) => {
    return this.auth.createUserWithEmailAndPassword(email, password)
  }
  
  doSendEmailVerification = (email) => {
    return this.auth.currentUser.sendEmailVerification()
  } 

  doConfirmEmailVerification = (email) => {
    return this.auth.currentUser.confirmEmailVerification()
  } 

  doSignInWithEmailAndPassword = (email, password) => {
    return this.auth.signInWithEmailAndPassword(email, password)      
  }
  
  doSignOut = () => { 
    return this.auth.signOut() 
  }
  
  doSendPasswordResetEmail = (email) => { 
    return this.auth.sendPasswordResetEmail(email) 
  }
  
  doConfirmPasswordReset = (code, newPassword) =>{
    return this.auth.confirmPasswordReset(code, newPassword)
  }
  
  doChangeEmail= (newEmail) =>{
    return this.auth.currentUser.updateEmail(newEmail)
  }

  doSendSignInLinkToEmail = (email) => {
    return this.auth.sendSignInLinkToEmail(email, actionCodeSettings)
  }
  
  doSignInWithGoogle = () => {
    return this.auth.signInWithPopup(this.providerGoogle)
  }
  
  doGetCurrentUser = () =>{
    return this.auth.currentUser.email
  }

  // *** User API ***
  
  user = uid => this.database.ref(`test/users/${uid}`) // TODO!!!: Remove test from ref
  users = () => this.database.ref('test/users')        // TODO!!!: Remove test from ref
  // Introducing Firestore, in parallel with Firebase Realtime Database 
  userData = uid => this.firestore.doc(`usersData/${uid}`)
  usersData = () => this.firestore.collection('usersData')
  
  //*** Gigs API ***
  
  gigs = uid => this.database.ref(`test/users/${uid}/gigs`) // TODO!!!: Remove test from ref
  // Introducing Firestore, in parallel with Firebase Realtime Database; again 
  savedGigs = uid => this.firestore.collection(`userData/${uid}/gigs`)

  //*** Pre-buy API ***
  
  // Introducing Firestore, in parallel with Firebase Realtime Database; again
  preBuyIndications = () => this.firestore.collection('preBuyIndications') 

}

export default Firebase